import { useContext } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useHasStudios } from '../hooks/useHasStudios';
import { NavBarContext } from '../App';

const ProtectedRoute = ({ children, requireStudio = false, redirectWhenNoStudio = '/studio-erstellen' }) => {
  const { isAuthenticated, status, user } = useSelector((state) => state.auth);
  const location = useLocation();
  const { isPhoneSize } = useContext(NavBarContext);
  const isPhoneViewport = typeof window !== 'undefined' ? window.innerWidth < 742 : false;
  const isPhone = Boolean(isPhoneSize || isPhoneViewport);

  const userId = user?.id || user?._id;
  const shouldCheckStudios = Boolean(requireStudio && status === 'succeeded' && isAuthenticated && userId);

  const { hasStudios, loading: hasStudiosLoading } = useHasStudios(shouldCheckStudios ? userId : null);

  if (status === 'loading' || status === 'idle' || (shouldCheckStudios && hasStudiosLoading)) {
    return null;
  }

  // If user is not authenticated, send them to login and keep target route in state
  if ((status === 'succeeded' && !isAuthenticated) || status === 'failed') {
    if (!isPhone) {
      return <Navigate to="/" state={{ from: location, requiresAuth: true }} replace />;
    }

    return <Navigate to="/anmelden" state={{ from: location, requiresAuth: true }} replace />;
  }

  if (shouldCheckStudios && !hasStudios) {
    return (
      <Navigate
        to={redirectWhenNoStudio}
        state={{ from: location, requiresStudio: true }}
        replace
      />
    );
  }

  return children;
};

export default ProtectedRoute;